import { FormattedMessage } from 'react-intl'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth'
import {
  deleteBrandFanGroup,
  DeleteBrandFanGroupActionTypes,
  deleteBrandFanGroupError,
  deleteBrandFanGroupSuccess,
  fetchBrandFanGroups,
  selectBrandFanGroupDeleteLink,
} from '@store/brandFans'
import { Toaster } from '@tribegroup'
import { networkRequest } from '@utils'

export function* handleDeleteBrandFanGroup(action: ReturnType<typeof deleteBrandFanGroup>) {
  try {
    const { groupId } = action.payload
    const authToken: string = yield select(selectAuthToken)
    const deleteBrandFanGroupLink: IHateoasLink = yield select(selectBrandFanGroupDeleteLink, groupId)

    if (!deleteBrandFanGroupLink) {
      throw new Error('Delete link not found')
    }

    yield call(
      networkRequest,
      deleteBrandFanGroupLink.method,
      deleteBrandFanGroupLink.href,
      undefined,
      authToken,
    )

    yield put(deleteBrandFanGroupSuccess(groupId))
    yield put(fetchBrandFanGroups())
    yield call(Toaster.createToast, FormattedMessage, {
      id: 'brandFans.groups.actions.deleteGroup.toast',
    })
  } catch (error) {
    yield put(deleteBrandFanGroupError(error))
  }
}

export function* watchDeleteBrandFanGroupRequest() {
  yield takeLatest(DeleteBrandFanGroupActionTypes.DELETE_REQUEST, handleDeleteBrandFanGroup)
}
